import React, { useEffect, useState } from "react";
import {  Grid, Typography } from "@mui/material";
import { ScreenContentWrapper } from "views/shared/ScreenContentWrapper";
import { Loading } from "views/shared/Loading";
import { getQueryStringParams } from "@theatticusapp/atticus-shared-components";
import { useNavigate } from "react-router-dom";
import { SCREEN_PATHS } from "../../constants";
import { Estate } from "models/Estate";
import { authApi, estateApi } from "apis";
import { UserProfileAPI } from "apis/UserProfileAPI";
import { useAuthContext } from "AuthContextWrapper";
import { Auth } from "aws-amplify";
import { User } from "models/User";
import { UserAPI } from "apis/UserAPI";


interface CognitoAttributesJson {
  sub:string,
  email_verified:boolean,
  "custom:country_id":number,
  "custom:language_id":number,
  phone_number_verified:boolean,
  phone_number:string, //probably includes + sign, etc
  given_name:string,
  family_name:string,
  email:string,
}


export async function createAndRedirect(user:User, redirectTo:string):Promise<Error|undefined> {

  try {
    const cognitoUser = await Auth.currentUserInfo() as { attributes : CognitoAttributesJson};

    // Migrate fields over from cognito
    if(!cognitoUser.attributes) {
      return new Error("couldn't find the current user")
    }

    const countryIdNum = cognitoUser.attributes["custom:country_id"]
    const countryId = countryIdNum.toString()
    const success = await UserProfileAPI.update({
      user_id: user.id,
      email: user.email,
      first_name: cognitoUser.attributes.given_name,
      last_name: cognitoUser.attributes.family_name,
      phone: cognitoUser.attributes.phone_number,
      countries_id: countryId,
      languages_id: cognitoUser.attributes["custom:language_id"].toString(),
    })
    if(success) {
      console.log("successfully migrated fields over from cognito")
    } else {
      return new Error("couldn't update your profile")
    }

    // Fetch estate associated with this user if there is one
    const estates = await estateApi.fetchEstates()
    let estate = new Estate(
        undefined, user.id, undefined, undefined, undefined, undefined, undefined, 
        undefined,undefined, undefined, undefined,
        undefined, undefined, user.first, user.middle, user.last, undefined, user.email, user.phone,
        undefined, countryIdNum
     )
    if(estates && estates[0]) {
      estate = estates[0]
    } 
    estate.hasWill = estate.hasWill || "No"
    estate.countryId = estate.countryId || countryIdNum || 1
    estate.stateId = estate.stateId || 1
    estate.userId =  user.id
  
    const saved = await estate.saveEstate()
    if(saved?.id) {
      console.log("user id saved to estate")
    } else {
      console.warn("couldn't associate user to estate")
    }

    const to = decodeURIComponent(redirectTo)
    window.location.href = to // can't use navigate() here because it may be a cross-domain navigation
    return
    
  } catch(e) {
    return new Error("Unable to get your account set up.  Please contact support@weareatticus.biz for assistance!")
  }
}


export const AccountCreationAndRedirectScreen = (): JSX.Element => {
  const { user } = useAuthContext()
  const params = getQueryStringParams();
  const [estateCreationError, setEstateCreationError] = useState<string|undefined>()

  useEffect(() => {
    async function doCreateAndRedirect() {
      if(!user) {
        return
      }
      if(!params.redirect_to) {
        params.redirect_to = SCREEN_PATHS.home
      }

      const err = await createAndRedirect(user, params.redirect_to)
      if(err) {
        setEstateCreationError(err.message)
      }
    }

    doCreateAndRedirect()
  }, [user])

  

  return (
    <ScreenContentWrapper
      pageSuffix="Setup"
      title="Getting your account set up"
      step={10}
      totalSteps={10}
      showBeta={false}
      style={{padding:"1rem 3rem 1rem 3rem"}}
    ><>

    {!estateCreationError ? (
        <Grid container style={{whiteSpace:"nowrap", verticalAlign:"middle", height:"4rem"}}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{height:"4rem"}}>
            <Loading />
          </Grid>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}  style={{height:"4rem", paddingTop:"2rem"}}>
            <Typography variant="h2" component={"p"}>
              You will be redirected shortly!
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <>
          {estateCreationError && <>
          <Typography color="error" component="p" style={{marginTop:"2rem"}}>
            An error occurred while creating your acccount.  Please email <a href="mailto:support@weareatticus.biz">support@weareatticus.biz</a>
            for assistance!  
          </Typography>
          <Typography color="error" component="p" style={{marginTop:"2rem"}}>
            The technical details are: {estateCreationError}
          </Typography>
        </>
        }
        </>
      )}
    </>
    </ScreenContentWrapper>
  );
};
